import { FC, PropsWithChildren } from "react";
import { SnackbarProvider } from "notistack";
import { makeStyles } from "@mui/styles";

import { IUserDto, useUser } from "@framework/provider-user";
import { useSettings } from "@framework/provider-settings";

import { themeProps } from "../components/theme";

let fontFamily = "";
if (typeof themeProps.options?.typography === "object") {
  fontFamily = themeProps.options.typography.fontFamily ?? "";
}

const useSnackbarStyles = makeStyles({
  root: {
    fontFamily,
    fontSize: "16px",
  },
  hiddenRoot: {
    display: "none",
  },
});

export enum PopupMsgMode {
  ALWAYS = 0,
  NEVER = 1,
  ALWAYS_EXCEPT_RECORDER_MODE = 2,
}

export const PopupAwareSnackbarProvider: FC<PropsWithChildren> = props => {
  const { children } = props;
  const classes = useSnackbarStyles();
  const user = useUser<IUserDto>();
  const settings = useSettings();

  const popupMsgModeRaw = user.profile?.interfaceSettings?.popupMsgMode;
  const popupMsgModeParsed =
    typeof popupMsgModeRaw === "number" ? popupMsgModeRaw : Number(popupMsgModeRaw ?? PopupMsgMode.ALWAYS);
  const popupMsgMode = [PopupMsgMode.ALWAYS, PopupMsgMode.NEVER, PopupMsgMode.ALWAYS_EXCEPT_RECORDER_MODE].includes(
    popupMsgModeParsed as PopupMsgMode,
  )
    ? (popupMsgModeParsed as PopupMsgMode)
    : PopupMsgMode.ALWAYS;

  const isRecorderMode = String(settings.getRangeType() ?? "") === "RECORDER_MODE";
  const shouldHideSnackbars =
    popupMsgMode === PopupMsgMode.NEVER ||
    (popupMsgMode === PopupMsgMode.ALWAYS_EXCEPT_RECORDER_MODE && isRecorderMode);

  const rootClassName = shouldHideSnackbars ? `${classes.root} ${classes.hiddenRoot}` : classes.root;

  return (
    <SnackbarProvider key={shouldHideSnackbars ? "hidden" : "visible"} classes={{ root: rootClassName }}>
      {children}
    </SnackbarProvider>
  );
};
